import { RequestHelper } from '../helpers/RequestHelper';
import { ResultHelper } from '../helpers/ResultHelper';
import { ServerApiMapper } from '../helpers/ServerModelHelper';
import { RunFlowTaskInfo } from '../models/RunFlowTaskInfo';
import { Module } from '../Module';
import { DeleteRunFlowTasksRequest } from '../ServerApi/requests/DeleteRunFlowTasksRequest';
import { GetRunFlowTasksRequest } from '../ServerApi/requests/GetRunFlowTasksRequest';
import { ResumeRunFlowTasksRequest } from '../ServerApi/requests/ResumeRunFlowTasksRequest';
import { RunFlowTasksRequest } from '../ServerApi/requests/RunFlowTasksRequest';
import { SetRunFlowTaskOutputStepsRequest } from '../ServerApi/requests/SetRunFlowTaskOutputStepsRequest';
import { SetRunFlowTasksPriorityRequest } from '../ServerApi/requests/SetRunFlowTasksPriorityRequest';
import { SetRunFlowTasksScheduleRequest } from '../ServerApi/requests/SetRunFlowTasksScheduleRequest';
import { IResult } from '../ServerApi/types/IResponse';
import { ErrorNotifyingServer } from '../services/ErrorNotifyingServer';
import { FetcherFactory } from '../services/FetcherFactory';
import { Resource } from './Resource';

export class RunFlowTasks extends Resource<RunFlowTaskInfo> {

  public static MAX_PRIORITY = 100;
  public static MIN_PRIORITY = 1;

  public static $inject = ['ErrorNotifyingServer', 'FetcherFactory'];

  constructor(private ErrorNotifyingServer: ErrorNotifyingServer, FetcherFactory: FetcherFactory) {
    super(FetcherFactory.getServerResourceFetcher(
      GetRunFlowTasksRequest,
      ServerApiMapper.runFlowTasks));
  }

  public del(ids: string[]): ng.IPromise<IResult> {
    return this.ErrorNotifyingServer.sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new DeleteRunFlowTasksRequest(idsBlock)),
      ResultHelper.combineResults);
  }

  public run(ids: string[]): ng.IPromise<IResult> {
    return this.ErrorNotifyingServer.sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new RunFlowTasksRequest(idsBlock)),
      ResultHelper.combineResults);
  }

  public setPriority(ids: string[], priority: number): ng.IPromise<IResult> {
    return this.ErrorNotifyingServer.sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new SetRunFlowTasksPriorityRequest(idsBlock, priority)),
      ResultHelper.combineResults);
  }

  public setSchedule(ids: string[], scheduleId: string): ng.IPromise<IResult> {
    return this.ErrorNotifyingServer.sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new SetRunFlowTasksScheduleRequest(idsBlock, scheduleId)),
      ResultHelper.combineResults);
  }

  public setOutputSteps(ids: string[], runAllOutputs: boolean, taskId: string): ng.IPromise<IResult> {
    return this.ErrorNotifyingServer.sendRequestAndDelay(
      new SetRunFlowTaskOutputStepsRequest({
        id: taskId,
        runAllOutputs: runAllOutputs,
        flowOutputStepIds: ids,
      })
    );
  }

  public resume(ids: string[]): ng.IPromise<IResult> {
    return this.ErrorNotifyingServer.sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new ResumeRunFlowTasksRequest(idsBlock)),
      ResultHelper.combineResults);
  }

}

Module.instance().service('RunFlowTasks', RunFlowTasks);
